'use strict';

var ParamsFactory = function ParamsFactory(hepService) {
  var runFrequency = hepService.getSimpleHepProperty('DYNAMIC_PRICING_RECOM_FREQUENCY');
  var Params = function Params(containerWidth, containerHeight) {
    var padding = {
      top: 25,
      bottom: runFrequency > 1 ? 60 : 50,
      left: 95,
      right: 95
    };
    var width = containerWidth - (padding.left + padding.right);
    var height = containerHeight - (padding.top + padding.bottom);
    return {
      width: width,
      height: height,
      containerWidth: containerWidth,
      containerHeight: containerHeight,
      padding: padding,
      yNumberOfTicks: 5,
      xAxisShift: 5,
      yAxisShift: 10,
      yAxisLabelShift: 65
    };
  };
  return Params;
};
ParamsFactory.$inject = ['HepService'];
module.exports = ParamsFactory;